import { defineMessages } from 'react-intl'

const scope = `procurify.platform.iam.features.grant-report-access-to-all-primary-categories.GrantReportAccessToAllPrimaryCategoriesPresenter`

export default defineMessages({
  successToastTitle: {
    id: `${scope}.successToastTitle`,
    defaultMessage: 'Success',
  },
  successToastMessage: {
    id: `${scope}.successToastMessage`,
    defaultMessage:
      '{userFullName} was successfully added to all {pluralPrimaryOrgCategoryLabel}.',
  },
  errorToastTitle: {
    id: `${scope}.errorToastTitle`,
    defaultMessage: 'Error',
  },
  errorToastDefaultMessage: {
    id: `${scope}.errorToastDefaultMessage`,
    defaultMessage:
      'Unable to give the user report access to all {pluralPrimaryOrgCategoryLabel}. Please try again.',
  },
})
